// Schema de la entidad `categorias_paro` — catálogo tenant-scoped de categorías de paro.
//
// Reemplaza el enum fijo `categoria_paro_enum` (FALLA_OPERACION | INTERVENCION_MANTENIMIENTO).
// Cada tenant gestiona sus propias categorías.
//
// Escritura: solo admin_tenant y super_admin.
// Lectura: todos los roles del tenant.
import { z } from 'zod';
// Validación de color: hex de 3 o 6 dígitos (e.g. '#EF4444' o '#F00').
// El campo es opcional/nullable — categorías sin color siguen siendo válidas.
const colorHexSchema = z
    .string()
    .regex(/^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/, 'El color debe ser un valor hex válido (#RGB o #RRGGBB)')
    .nullable()
    .optional();
// =============================================================================
// Output — DTO de respuesta API (GET /api/admin/categorias-paro)
// =============================================================================
export const categoriaParoOutputSchema = z.object({
    id: z.string().uuid(),
    tenant_id: z.string().uuid(),
    codigo: z.string(),
    nombre: z.string(),
    /** Color en formato hex (#RGB o #RRGGBB). Null si no fue configurado. */
    color: z
        .string()
        .regex(/^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/, 'El color debe ser un valor hex válido (#RGB o #RRGGBB)')
        .nullable(),
    /** Reservado para F2 — OEE/disponibilidad. Nunca afecta cálculos en F1. */
    afecta_disponibilidad: z.boolean(),
    activa: z.boolean(),
});
// =============================================================================
// Input — Crear categoría (POST /api/admin/categorias-paro)
// =============================================================================
export const crearCategoriaParoSchema = z.object({
    codigo: z.string().trim().min(1).max(40),
    nombre: z.string().trim().min(1).max(120),
    /** Color hex opcional. Nullable aceptado. tenant_id NUNCA va acá — viene del JWT. */
    color: colorHexSchema,
    /** Reservado F2. Default false si no se envía. */
    afecta_disponibilidad: z.boolean().optional(),
});
// =============================================================================
// Input — Actualizar categoría (PATCH /api/admin/categorias-paro/:id)
// =============================================================================
export const actualizarCategoriaParoSchema = z
    .object({
    nombre: z.string().trim().min(1).max(120),
    color: colorHexSchema,
    afecta_disponibilidad: z.boolean(),
    /** Soft delete: pasar activa:false para desactivar. */
    activa: z.boolean(),
})
    .partial();
// =============================================================================
// Resumen mínimo — usado en respuestas anidadas (análisis de paros, etc.)
// =============================================================================
/** Datos de categoría embebidos en respuestas de causales y análisis. */
export const categoriaParoResumenSchema = z.object({
    id: z.string().uuid(),
    codigo: z.string(),
    nombre: z.string(),
    color: z.string().nullable(),
});
//# sourceMappingURL=categoria_paro.js.map